export const SIP_STATUS_MESSAGE = {
  TRYING_TO_RECONNECT: 'Trying to reconnect.',
  REGISTRATION_FAILED: 'SIP registration failed, click for reconnection',
  AVAILABLE: 'Calling service is available.',
  UNAVAILABLE: 'Calling service is unavailable. Click to retry.',
} as const;
